

{
  "familyId": "STU-SAMENVATTEN",
  "questions": [
    {
      "id": "STU-SAMENVATTEN-001",
      "familyId": "STU-SAMENVATTEN",
      "module": "Studievaardig",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_samenvatten",
      "questionType": "multiple_choice",
      "question": "Je moet een tekst van 3 pagina's samenvatten. Wat doe je als eerste?",
      "options": ["De hele tekst doorlezen", "Meteen beginnen met schrijven", "Alleen de eerste alinea lezen", "De moeilijke woorden opzoeken"],
      "correctAnswer": 0,
      "context": "Eerste stap bij samenvatten",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "stu.samenvatten.write_first", "label": "Begint te schrijven zonder overzicht", "optionIndex": 1 },
          { "id": "stu.samenvatten.only_intro", "label": "Denkt dat de eerste alinea alles dekt", "optionIndex": 2 },
          { "id": "stu.samenvatten.vocab_first", "label": "Verwart leestechniek met woordstudie", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Samenvatten: eerste stap",
            "content": "Lees altijd eerst de hele tekst door. Zo begrijp je het grote plaatje voordat je gaat samenvatten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "samenvatten_eerste_stap",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De eerste stap is de hele tekst doorlezen. Zo krijg je overzicht van onderwerp en opbouw. Pas daarna kun je bepalen wat belangrijk is.",
        "solutionSteps": [
          "Stap 1: Lees de hele tekst door",
          "Stap 2: Bepaal de hoofdgedachte",
          "Stap 3: Markeer kernwoorden per alinea",
          "Stap 4: Schrijf de samenvatting in eigen woorden"
        ],
        "distractorExplanations": {
          "0": "Goed! Eerst de hele tekst doorlezen geeft je een overzicht.",
          "1": "Zonder de hele tekst te kennen, mis je vaak het belangrijkste punt. Onthoud: eerst lezen, dan schrijven.",
          "2": "De hoofdgedachte kan ook in het midden of aan het einde staan. Lees altijd alles.",
          "3": "Moeilijke woorden opzoeken kan helpen, maar de eerste stap is de tekst lezen voor het overzicht."
        }
      }
    },
    {
      "id": "STU-SAMENVATTEN-002",
      "familyId": "STU-SAMENVATTEN",
      "module": "Studievaardig",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_samenvatten",
      "questionType": "multiple_choice",
      "question": "Welke techniek helpt het meest bij het samenvatten van een tekst?",
      "options": ["Kernwoorden markeren per alinea", "De tekst letterlijk overschrijven", "Alleen de titel lezen", "Elke zin in je eigen woorden schrijven"],
      "correctAnswer": 0,
      "context": "Samenvattechniek",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.samenvatten.copy_verbatim", "label": "Verwart samenvatten met overschrijven", "optionIndex": 1 },
          { "id": "stu.samenvatten.title_only", "label": "Denkt dat titel genoeg is", "optionIndex": 2 },
          { "id": "stu.samenvatten.paraphrase_all", "label": "Vat alles per zin samen (te lang)", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kernwoorden markeren",
            "content": "Markeer per alinea 1-3 kernwoorden. Die vormen het skelet van je samenvatting. Schrijf daarna in je eigen woorden wat de alinea vertelt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "samenvatten_techniek",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Kernwoorden markeren per alinea is de beste techniek. Zo vind je snel de belangrijkste informatie en kun je die in eigen woorden opschrijven — kort en krachtig.",
        "solutionSteps": [
          "Lees elke alinea",
          "Markeer 1-3 kernwoorden per alinea",
          "Gebruik die kernwoorden als skelet",
          "Schrijf in je eigen woorden"
        ],
        "distractorExplanations": {
          "0": "Goed! Kernwoorden markeren = de belangrijkste techniek.",
          "1": "Samenvatten is het tegenovergestelde van overschrijven — je maakt korter, niet langer.",
          "2": "De titel geeft alleen het onderwerp, niet de inhoud. Lees de hele tekst.",
          "3": "Elke zin herschrijven wordt net zo lang als de tekst. Selecteer alleen het belangrijkste."
        }
      }
    },
    {
      "id": "STU-SAMENVATTEN-003",
      "familyId": "STU-SAMENVATTEN",
      "module": "Studievaardig",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_samenvatten",
      "questionType": "text_highlight",
      "question": "Tik op het kernwoord dat het beste bij deze alinea past. Welk woord dekt alles wat in de tekst staat?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Er bestaan veel verschillende wolkensoorten. Stapelwolken zijn dik en zien eruit als witte bollen. Sluierwolken zijn dun en hangen heel hoog. Regenwolken zijn donker en grijs.",
        "correctHighlights": ["wolkensoorten"]
      },
      "context": "Kernwoord identificeren in een korte tekst",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "Er bestaan veel verschillende wolkensoorten. Stapelwolken zijn dik en zien eruit als witte bollen. Sluierwolken zijn dun en hangen heel hoog. Regenwolken zijn donker en grijs.",
            "instruction": "Lees de alinea hieronder"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kernwoord kiezen",
            "content": "Een goed kernwoord dekt de hele alinea — niet te breed (zoals 'weer' of 'lucht'), niet te smal (zoals 'regen'). 'Wolkensoorten' past precies: het dekt alle drie de genoemde wolken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "samenvatten_kernwoord",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het beste kernwoord is 'wolkensoorten'. Dat dekt alle drie de genoemde wolken (stapel-, sluier- en regenwolken). Test: 'Past dit op de hele alinea?' Ja → goed kernwoord.",
        "solutionSteps": [
          "Bekijk de alinea: stapelwolken, sluierwolken, regenwolken",
          "Vraag: wat hebben ze gemeen? → wolkensoorten",
          "Check: dekt 'wolkensoorten' alle 3 de soorten? Ja ✓"
        ]
      }
    },
    {
      "id": "STU-SAMENVATTEN-004",
      "familyId": "STU-SAMENVATTEN",
      "module": "Studievaardig",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_samenvatten",
      "questionType": "multiple_choice",
      "question": "Wat hoort NIET in een goede samenvatting?",
      "options": ["Voorbeelden en details uit de tekst", "De hoofdgedachte", "De belangrijkste punten", "De conclusie van de schrijver"],
      "correctAnswer": 0,
      "context": "Wat laat je weg?",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.samenvatten.omit_main_idea", "label": "Denkt dat hoofdgedachte weg mag", "optionIndex": 1 },
          { "id": "stu.samenvatten.omit_key_points", "label": "Denkt dat belangrijke punten weg mogen", "optionIndex": 2 },
          { "id": "stu.samenvatten.omit_conclusion", "label": "Denkt dat conclusie weg mag", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wat laat je weg?",
            "content": "Laat details, voorbeelden en herhalingen weg. Houd alleen de hoofdgedachte, belangrijkste punten en conclusie over.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "samenvatten_weglaten",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Voorbeelden en details laat je weg. Hou alleen de hoofdgedachte, belangrijkste punten en conclusie over — zo blijft je samenvatting kort en sterk.",
        "solutionSteps": [
          "WEL: hoofdgedachte, belangrijkste punten, conclusie",
          "NIET: voorbeelden, details, herhalingen",
          "Vuistregel: max. 1/4 van de oorspronkelijke lengte"
        ],
        "distractorExplanations": {
          "0": "Goed! Voorbeelden en details laat je weg.",
          "1": "De hoofdgedachte is juist het allerbelangrijkste — daarmee begin je.",
          "2": "Belangrijkste punten vormen het skelet van je samenvatting.",
          "3": "De conclusie is het eindpunt van de tekst en hoort er bij."
        }
      }
    },
    {
      "id": "STU-SAMENVATTEN-005",
      "familyId": "STU-SAMENVATTEN",
      "module": "Studievaardig",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_samenvatten",
      "questionType": "ordering",
      "question": "Zet de stappen voor het samenvatten in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["Lees de hele tekst door", "Bepaal de hoofdgedachte", "Markeer kernwoorden per alinea", "Schrijf de samenvatting in je eigen woorden"],
        "correctOrder": [0, 1, 2, 3]
      },
      "context": "Volgorde van samenvatten",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde samenvatten",
            "content": "1) Lees de hele tekst. 2) Bepaal de hoofdgedachte. 3) Markeer kernwoorden per alinea. 4) Schrijf in je eigen woorden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "samenvatten_volgorde",
      "variantIndex": 5,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Juiste volgorde: lees → hoofdgedachte → kernwoorden → schrijven. Eerst overzicht, dan structuur, dan details, dan pas eigen tekst.",
        "solutionSteps": [
          "Stap 1: Lees de hele tekst (overzicht)",
          "Stap 2: Bepaal de hoofdgedachte (waar gaat het over?)",
          "Stap 3: Markeer kernwoorden (details selecteren)",
          "Stap 4: Schrijf in eigen woorden (verwerken)"
        ]
      }
    },
    {
      "id": "STU-SAMENVATTEN-006",
      "familyId": "STU-SAMENVATTEN",
      "module": "Studievaardig",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_samenvatten",
      "questionType": "true_false_series",
      "question": "Lees de alinea hieronder. Beoordeel elke uitspraak: waar of niet waar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "De alinea gaat vooral over verschillende sportsoorten.", "isTrue": true },
          { "text": "Voetbal wordt genoemd als individuele sport.", "isTrue": false },
          { "text": "Tennis wordt in de tekst genoemd.", "isTrue": true },
          { "text": "Het kernwoord van deze alinea is 'voetbal'.", "isTrue": false }
        ]
      },
      "context": "Tekstbegrip + kernwoord-keuze",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "Er bestaan veel verschillende sportsoorten. Bij teamsporten zoals voetbal en hockey speel je met een groep. Bij individuele sporten zoals tennis en zwemmen sport je alleen. Buitensporten doe je in de natuur, binnensporten doe je in een sportzaal.",
            "instruction": "Lees de alinea"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tekst nauwkeurig lezen",
            "content": "Lees precies wat er staat. 'Voetbal' wordt in de tekst genoemd als teamsport, niet als individuele sport. Het kernwoord 'sportsoorten' dekt de hele alinea — 'voetbal' is alleen één voorbeeld.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "samenvatten_tekstbegrip",
      "variantIndex": 6,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De alinea gaat over sportsoorten — dat dekt alles. Voetbal staat erin als teamsport (niet individueel). Tennis wordt genoemd als individuele sport. Het kernwoord is 'sportsoorten', niet 'voetbal' (voetbal is maar één voorbeeld).",
        "solutionSteps": [
          "1. Onderwerp = sportsoorten ✓",
          "2. Voetbal = teamsport, niet individueel ✗",
          "3. Tennis = wel genoemd ✓",
          "4. Kernwoord moet alles dekken → 'sportsoorten', niet 'voetbal' ✗"
        ]
      }
    }
  ]
}

